import { createSlice } from "@reduxjs/toolkit";

// Define the initial state
const initialState = {
    isDataMappingAcrossStudies: 1,
    disableCentralizedUAM: false,
    centralizedDataMappingSelectedStudyType: null,
    centralizedDataMappingSelectedStudyTypeMethod: null,
};

// Create the slice
export const dataControlStore = createSlice({
    name: "dataControlStore",
    initialState,
    reducers: {
        // Action to load the value of isDataMappingAcrossStudies
        loadIsDataMappingAcrossStudies: (state, action) => {
            state.isDataMappingAcrossStudies = action.payload;
        },
        loadCentralizedDataMappingSelectedStudyTypeState: (state, action) => {
            state.centralizedDataMappingSelectedStudyType = action.payload;
        },
        loadCentralizedDataMappingSelectedStudyTypeMethodState: (state, action) => {
            state.centralizedDataMappingSelectedStudyTypeMethod = action.payload;
        },

        // Action to reset the state to its initial values
        resetDataControlStoreState: () => initialState,
    },
});

// Export the actions created by the slice
export const { loadIsDataMappingAcrossStudies, loadCentralizedDataMappingSelectedStudyTypeState, loadCentralizedDataMappingSelectedStudyTypeMethodState } = dataControlStore.actions;

// Export the reducer to be used in the store
export default dataControlStore.reducer;
